import React  from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
 } from "reactstrap";
import { Spinner } from 'components/Icons/Spinner';

import { CenterMessageCard } from 'components/CenterMessageCard';


import  { StudentCard } from 'alumni-components/UserCards/StudentCard';
import {TeacherCard } from 'alumni-components/UserCards/TeacherCard'; 

   const SearchResult = ( { personas, isSearching, qryString, qryAll  } ) =>  {

        return (
          <div className="content">

{/*  
    <div className="text-center">
      <Progress value={2 * 20} />
      <Progress color="success" value="25" />
      <Progress color="info" value={50} />
      <Progress color="warning" value={75} />
      <Progress color="danger" value="100" />
    </div>
  */}

            <>
            {(personas && !isSearching) ?
              <>
                {personas.length > 0 ?
                <Card className="card-plain">
                  <CardBody>
                  
                    <Row>
                      { personas.map( ( persona, idx ) => { 
                        return (
                          <>
                              <Col sm="3">
                                {persona.is_employee==='Y'?
                                  <TeacherCard 
                                    persona={persona} 
                                />
                                :
                                  <StudentCard 
                                    persona={persona}
                                    showCourse= {true}
                                    />
                                }
                                
                              </Col>
                            {(idx+1 % 4 ===0) && '</Row><Row>' } 
                          </> 
                            )
                        } ) }
                    </Row>
                  </CardBody>
                </Card>
                :
                  <CenterMessageCard 
                      icon="fa-hand-paper-o"
                      title="Oooops 🧐">
                        Tu texto <b>{qryString}{qryAll}</b> no fue encontrado entre los alumnos matriculados. 
                  </CenterMessageCard> 
                }
              </>
            :
            <>
            <Spinner size="XL" />
            </>
            }
          </>
        </div>
        );
        }

export { SearchResult } ;
